// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-cd34a77e] {\n  color: var(--h1HeaderFontColor, var(--text-gray-900));\n  font-family: var(--h1HeaderFontTypeface, inherit);\n  font-weight: var(--h1HeaderFontWeight, 700);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
